var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { "max-width": "45%", bus: _vm.busModal, fixedActions: "" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                attrs: {
                  title: "Extensão AAWZ — Tokens de acesso",
                  underlined: ""
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "d-flex align-center justify-end mt-4" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v("Fechar")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pa-1" }, [
        _c("p", { staticClass: "az-text-secondary az-size-14 mb-4" }, [
          _vm._v(
            " Tokens de dispositivo permitem que a extensão Chrome da AAWZ se conecte à sua conta sem necessidade de senha. Cada token é exibido apenas uma vez no momento da criação. "
          )
        ]),
        _vm.novoToken
          ? _c("div", { staticClass: "mb-5 pa-3 rounded token-callout" }, [
              _c(
                "div",
                { staticClass: "d-flex align-center mb-1 az-gap-small" },
                [
                  _c("icon-svg", {
                    staticClass: "token-callout-icon",
                    attrs: { name: "warning-status", size: "16" }
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "az-text-primary az-size-12 font-semibold token-callout-text"
                    },
                    [_vm._v(" Token gerado — salve agora! ")]
                  )
                ],
                1
              ),
              _c(
                "p",
                {
                  staticClass:
                    "az-text-primary az-size-12 mb-2 token-callout-text"
                },
                [
                  _vm._v(
                    " Este token só é exibido uma vez. Copie e configure na extensão antes de fechar esta janela. "
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex align-center az-gap-small" },
                [
                  _c("InputByType", {
                    staticClass: "flex-grow-1 token-field",
                    attrs: {
                      type: "text",
                      value: _vm.novoToken,
                      readonly: "",
                      dense: "",
                      outlined: "",
                      "hide-details": ""
                    }
                  }),
                  _c(
                    "BaseButton",
                    {
                      attrs: { sm: "", fitContent: "", outline: "" },
                      on: { click: _vm.copiarToken }
                    },
                    [
                      _c("icon-svg", {
                        staticClass: "mr-1",
                        attrs: { name: "copy", size: "16" }
                      }),
                      _vm._v(" Copiar ")
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "mb-5" }, [
          _c(
            "p",
            { staticClass: "az-text-primary az-size-14 font-semibold mb-2" },
            [_vm._v("Gerar novo token")]
          ),
          _c(
            "div",
            { staticClass: "d-flex align-center az-gap-small" },
            [
              _c("InputByType", {
                staticClass: "flex-grow-1",
                attrs: {
                  type: "text",
                  label: "Nome do dispositivo (ex: Notebook do trabalho)",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  disabled: _vm.gerandoToken
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.gerarToken($event)
                  }
                },
                model: {
                  value: _vm.nomeNovo,
                  callback: function($$v) {
                    _vm.nomeNovo = $$v
                  },
                  expression: "nomeNovo"
                }
              }),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    fitContent: "",
                    loading: _vm.gerandoToken,
                    disabled: !_vm.nomeNovo || !_vm.nomeNovo.trim()
                  },
                  on: { click: _vm.gerarToken }
                },
                [_vm._v(" Gerar ")]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          [
            _c(
              "FeedbackWrapper",
              {
                attrs: {
                  loading: _vm.carregandoLista,
                  "no-data": _vm.semTokens,
                  message: "Nenhum token ativo.",
                  "min-height": 120
                }
              },
              [
                _c("BaseTable", {
                  attrs: {
                    title: "Tokens ativos",
                    subtitle: "Tokens de acesso ativos da extensão AAWZ.",
                    headers: _vm.headers,
                    items: _vm.tokens,
                    "hide-default-footer": "",
                    "items-per-page": -1,
                    disableMarginTop: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.name",
                      fn: function(ref) {
                        var row = ref.item
                        return [_vm._v(" " + _vm._s(row.name || "—") + " ")]
                      }
                    },
                    {
                      key: "item.token_prefix",
                      fn: function(ref) {
                        var row = ref.item
                        return [
                          _c("code", { staticClass: "token-prefix" }, [
                            _vm._v(_vm._s(row.token_prefix || "—") + "…")
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.created_at",
                      fn: function(ref) {
                        var row = ref.item
                        return [
                          _c(
                            "span",
                            { staticClass: "az-text-secondary az-size-12" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatarData(row.created_at)) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function(ref) {
                        var row = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-end" },
                            [
                              _vm.revogandoId === row.id
                                ? _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      size: "18",
                                      width: "2",
                                      color: "var(--muted)"
                                    }
                                  })
                                : _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.confirmarRevogacao(
                                                              row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("icon-svg", {
                                                      attrs: {
                                                        name: "delete",
                                                        size: "18",
                                                        color: "var(--muted)"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [_c("span", [_vm._v("Revogar token")])]
                                  )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }